<template>
  <v-app>
    <Content />
  </v-app>
</template>

<script>
import Content from './views/content/Content'
import store from './store/store.js'


export default {
  name: 'app',
  components: {
    Content
  },
  
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue